import React from 'react';
import './PauseMenu.css'
import Btn from '../Common/Btn';

const PauseMenu = (props) => {
    return ( 
        <div className='PauseMenu'>
            <div className='PauseTitle'>
                <p>
                    Paused
                </p>
            </div>

            <div className='MenuBtns'>
                <Btn BtnText='Resume' BtnStyle='BlueBtn' onClick={props.ResumeClick}/>
                <Btn BtnText='Quit' BtnStyle='GoldBtn' BtnPath='/'/>
            </div>
        </div>
     );
}
 
export default PauseMenu;